(ns authentication.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::error? boolean?)
(s/def ::message (s/nilable string?))
(s/def ::form (s/keys :opt-un [::error?
                               ::message
                               ::submitting?]))
(s/def ::mfa-code (s/nilable string?))

(s/def ::authentication (s/keys :opt-un [::form
                                         ::mfa-code]))

